module.exports = __webpack_public_path__ + "img/165.42df11a0.svg";